import * as rrd from 'react-router-dom';
import { useEffect, useRef } from 'react';

import { oauth } from '@/lib';
import { PlatformIcon } from '@/components';
import { PLATFORM_CAPTIONS, PLATFORM_COLORS } from '@/constants';

const { useParams, useNavigate, useSearchParams } = rrd.default ?? rrd;

const platformHandlers = {
  spotify: oauth.spotify.handleCallback,
  youtube: oauth.youtube.handleCallback,
};

const OAuthCallback = () => {
  const handled = useRef(false);

  const navigate = useNavigate();
  const { platform } = useParams();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (handled.current) return;

    handled.current = true;

    const returnPath = sessionStorage.getItem('oauth_return_path') || '/';

    sessionStorage.removeItem('oauth_return_path');

    const handler = platformHandlers[platform];

    if (!handler) {
      navigate('/', { replace: true });
      return;
    }

    handler(searchParams)
      .catch((error) =>
        console.error(`${platform} OAuth callback failed:`, error)
      )
      .finally(() => navigate(returnPath, { replace: true }));
  }, []);

  const color = PLATFORM_COLORS[platform];

  const caption = PLATFORM_CAPTIONS[platform];

  return (
    <main
      className="container py-4 d-flex align-items-center"
      style={{ minHeight: 'calc(100vh - 410px)' }}
    >
      <div className="row justify-content-center text-center w-100">
        <div className="col-md-8 col-lg-6">
          {caption && (
            <div className="mb-3">
              <PlatformIcon
                fontSize="3rem"
                variant="primary"
                platform={platform}
              />
            </div>
          )}

          <p className="text-muted mb-4">
            {caption ? `Connecting to ${caption}...` : 'Connecting...'}
          </p>

          <div
            role="status"
            className="spinner-border"
            style={color ? { color } : undefined}
          >
            <span className="visually-hidden">Connecting...</span>
          </div>
        </div>
      </div>
    </main>
  );
};

export default OAuthCallback;
